import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA, MatDialog,
  MatDialogConfig, MatDialogRef
} from '@angular/material/dialog';

/**
 * Format of data for the dialog
 */
export interface FollowUpTableDialogData {
  entityId: string;
  campaignId: string;
}

@Component({
  selector: 'app-follow-up-table-dialog',
  templateUrl: './follow-up-table.dialog.html'
})
export class FollowUpTableDialog {
  static open(dialog: MatDialog, config: MatDialogConfig<FollowUpTableDialogData>) {
    return dialog.open(FollowUpTableDialog, config);
  }

  constructor(
    public dialogRef: MatDialogRef<FollowUpTableDialog>,
    @Inject(MAT_DIALOG_DATA) public data: FollowUpTableDialogData
  ) { }

  close(data: any = null) {
    this.dialogRef.close(data);
  }
}
